
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply component specific CSS */
.accordion-title{color:var(--outline-soft-black);font-family:var(--ff-display);font-size:var(--fs-4xl);line-height:var(--lh-4xl)}.accordion-title.mobile{color:var(--outline-soft-black);font-size:var(--fs-lg);line-height:var(--lh-lg)}::slotted(outline-heading){margin-bottom:2.5rem}`;